import React, { useState, useEffect } from 'react'
import { Card, Row, Col } from 'react-bootstrap'
import { Form, RadioGroup, Radio, Input, InputPicker, AutoComplete } from 'rsuite';
import LegacySpinnerIcon from "@rsuite/icons/legacy/Spinner";
import { getEfCredentials, getVfCredentials } from '../../../services/Shared/codeTable.service';
import RedStar from '../GenericComponents/RedStar';
import TextArea from '../GenericComponents/TextArea';
import { AccessibleInputPicker } from '../GenericComponents/AccessibleComponents';

function EmploymentLicensure({ type = "VF", isReadOnly, option, setOption, firmNumber, clearFirmNumber }) {
    const [creds, setCreds] = useState();
    const [contactLoading, setContactLoading] = useState(false);
    useEffect(() => {
        if (firmNumber?.licenseNumber)
            if (type == "VF") {
                getVfCredentials(firmNumber.licenseNumber).then(setCreds);
            }
            else {
                getEfCredentials(firmNumber.licenseNumber).then(setCreds);
            }
    }, [firmNumber])
    const updateCreds = (value) => {
        setContactLoading(true)
        if (type == "VF")
            getVfCredentials(value).then(setCreds);
        else if (type == "EF")
            getEfCredentials(value).then(setCreds);
        setContactLoading(false);
    }
    const test = () => {
        clearFirmNumber();
    }
    return (
        <Card>
            <Card.Header><h6>Employment Licensure</h6></Card.Header>
            <Card.Body>
                <Form.Group>
                    <Row>
                        <Col>
                            <Form.ControlLabel><b>If approved for licensure in Louisiana, I will be employed by:<RedStar /></b></Form.ControlLabel>
                            <Form.Control
                                name="licensedFirmType"
                                accepter={RadioGroup}
                                onChange={x => setOption(x)}
                                readOnly={isReadOnly}>
                                <Radio value="licensed">A firm that is currently licensed in Louisiana. If firm has an expired status, please select second option.</Radio>
                                {option == "licensed" &&
                                    <Form.Control
                                        accepter={AccessibleInputPicker}
                                        ariaLabel="Firm License Number"
                                        block
                                        data={creds}
                                        name="firmNumber"
                                        placeholder="Firm #"
                                        cleanable={false}
                                        onOpen={test}
                                        onSearch={updateCreds}
                                        renderMenu={menu => {
                                            if (contactLoading) {
                                                return (
                                                    <p style={{ padding: 4, color: '#999', textAlign: 'center' }}>
                                                        <LegacySpinnerIcon spin /> Loading...
                                                    </p>
                                                );
                                            }
                                            return menu;
                                        }}
                                        readOnly={isReadOnly} />
                                }
                                <Radio value="unlicensed">A firm that is not licensed or expired in Louisiana. I understand a firm application or reinstate firm application must be submitted within three weeks of receiving or reinstating a Louisiana license.</Radio>
                                {option == "unlicensed" &&
                                    <>
                                        <Form.Group style={{ marginBottom: "0" }}>
                                            <Form.ControlLabel className="d-none">Firm/Employer Name</Form.ControlLabel>
                                            <Form.Control name="employedBy" placeholder="Firm/Employer Name" readOnly={isReadOnly} />
                                            <Form.HelpText className="d-none">Firm/Employer Name</Form.HelpText>
                                        </Form.Group>
                                    </>
                                }
                                <Radio value="soleProprietor">I am a Sole Proprietor. In the comment box below, please list the name you will be practicing under in the state of Louisiana if approved.</Radio>
                                {option == "soleProprietor" &&
                                    <Form.ControlLabel className="ms-5">
                                        2301.C. Unless otherwise provided, sole proprietorships which are <b><u>not legal entities</u></b>, and which bear the full name of the owner who is a licensed professional are exempt from the application of this Chapter. Such sole proprietorships are not required to be licensed as engineering or land surveying firms with the board. Sole proprietorships which are not legal entities, and which do not bear the full name of the owner who is a licensed professional must be licensed with the board as an engineering or land surveying firm and must comply with all the provisions of this Chapter. For purposes of this §2301.C, legal entities is defined as domestic or foreign partnerships, associations, cooperatives, ventures, corporations, limited liability companies, limited liability partnerships, or other entities.
                                    </Form.ControlLabel>
                                }
                                <Radio value="unemployed">I will be seeking employment if approved for licensure in the state of Louisiana.</Radio>
                            </Form.Control>
                        </Col>
                        <Form.HelpText className="d-none">Licensed Firm Type</Form.HelpText>
                    </Row>
                </Form.Group>
                <br />
                <Form.Group controlId="comment">
                    <Form.ControlLabel><b>Comments:</b></Form.ControlLabel>
                    <Form.Control
                        readOnly={isReadOnly}
                        accepter={TextArea}
                        rows={5}
                        name="comment" />
                    <Form.HelpText className="d-none">Comments</Form.HelpText>
                </Form.Group>
            </Card.Body>
        </Card>
    );
}

export default EmploymentLicensure